import { render, staticRenderFns } from "./instructionTitle.vue?vue&type=template&id=616ad068"
import script from "./instructionTitle.vue?vue&type=script&lang=js"
export * from "./instructionTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports